import { buildQuerySummary } from '@coveo/headless';
import { RsHTMLElement } from '../rs-htmlelement.js';
import styles from 'inline:./rs-refine-toggle.scss';

export class RsRefineToggle extends RsHTMLElement {
    querySummaryState;

    styles() {
        return styles;
    }

    mounted() {
        const querySummary = buildQuerySummary(this.bindings.engine);
        querySummary.subscribe(() => {
            this.querySummaryState = querySummary.state;
            this.updateButton();
        });

        this.initEvents();
    }

    initEvents() {
        this.label.addEventListener('click', () => {
            this.toggleModal();
        });

        this.modalClose.addEventListener('click', () => this.closeModal());
        this.button.addEventListener('click', () => this.closeModal());
    }

    closeModal() {
        this.modal.classList.remove('visible');
        document.documentElement.classList.remove('modal-open');
    }

    renderButton() {
        return `<div class="button">${this.i18n.t('rs.refineToggleShowResults')} (<span class="result-total"></span>)</div>`;
    }

    renderLabel() {
        return `<div class="label">${this.labelText}</div>`;
    }

    renderModal() {
        return `
            <div class="modal">
                <div class="inner">
                    ${this.renderModalClose()}
                    <div class="content">
                        <div class="sections">
                            <div class="section">
                                <div class="section-title">${this.i18n.t('rs.refineToggleSortBy')}</div>
                                ${this.renderModalSortDropdown()}
                            </div>
                            <div class="section">
                                <div class="section-title">${this.i18n.t('rs.refineToggleFilters')}</div>
                                <div class="facets"></div>
                            </div>
                        </div>
                        ${this.renderButton()}
                    </div>
                </div>
            </div>
        `;
    }

    renderModalClose() {
        return `
            <div class="close">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M25.5 6.5L6.5 25.5M6.5 6L26 25.5" stroke="currentColor" stroke-linecap="round"/>
                </svg>
            </div>
        `;
    }

    renderModalFacets() {
        this.facets.innerHTML = '';

        Array.from(this.searchInterface.querySelectorAll('atomic-facet, atomic-category-facet'))
                .forEach((facet) => this.facets.appendChild(facet.cloneNode(true)));
    }

    renderModalSortDropdown() {
        return `<rs-sort-dropdown autofill standalone></rs-sort-dropdown>`;
    }

    toggleModal() {
        this.modal.classList.toggle('visible');

        this.facets.innerHTML = '';

        if (this.modal.classList.contains('visible')) {
            document.documentElement.classList.toggle('modal-open', this.modal.classList.contains('visible'));

            this.renderModalFacets();
        }
    }

    updateButton() {
        this.resultTotal.textContent = this.querySummaryState.total?.toLocaleString(this.i18n.language);
    }

    get button() {
        return this.shadow.querySelector('.button');
    }

    get facets() {
        return this.shadow.querySelector('.facets');
    }

    get labelText() {
        return this.i18n.t('rs.refineToggleSortBy');
    }

    get label() {
        return this.shadow.querySelector('.label');
    }

    get modal() {
        return this.shadow.querySelector('.modal');
    }

    get modalClose() {
        return this.modal.querySelector('.close');
    }

    get resultTotal() {
        return this.shadow.querySelector('.result-total');
    }

    async render() {
        await customElements.whenDefined('rs-sort-dropdown');

        this.shadow.innerHTML = `
            <div class="refine-toggle">
                ${this.renderLabel()}
                ${this.renderModal()}
            </div>
        `;
    }
};